var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.40625,
    y: 0.625,
    width: 18.75,
    height: 18.75,
    rx: 9.375,
    fill: "#367F9A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.40625,
    y: 0.625,
    width: 18.75,
    height: 18.75,
    rx: 9.375,
    stroke: "#367F9A",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7453 7.54221L9.49533 13.7922C9.45906 13.8285 9.41597 13.8573 9.36855 13.877C9.32113 13.8967 9.2703 13.9068 9.21897 13.9068C9.16763 13.9068 9.1168 13.8967 9.06938 13.877C9.02196 13.8573 8.97888 13.8285 8.9426 13.7922L6.20823 11.0578C6.13493 10.9845 6.09375 10.8851 6.09375 10.7815C6.09375 10.6778 6.13493 10.5784 6.20823 10.5051C6.28152 10.4318 6.38093 10.3906 6.48459 10.3906C6.58825 10.3906 6.68766 10.4318 6.76096 10.5051L9.21897 12.9636L15.1926 6.98947C15.2659 6.91618 15.3653 6.875 15.469 6.875C15.5726 6.875 15.672 6.91618 15.7453 6.98947C15.8186 7.06277 15.8598 7.16218 15.8598 7.26584C15.8598 7.3695 15.8186 7.46891 15.7453 7.54221Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.5cb8ce1701b75156d28a50ea59cd2c95.svg";
export { ForwardRef as ReactComponent };